import { diContainer } from '../../libs/container';
import { extractErrorFromResponse, AppError } from './ErrorHandler';

export class FetchError extends Error {
    public readonly errorCode: string;
    public readonly userMessage: string;
    public readonly status: number;
    public readonly ok: boolean;
    public readonly appError: AppError;

    constructor(status: number, ok: boolean, appError: AppError) {
        super(appError.userMessage);
        this.status = status;
        this.ok = ok;
        this.errorCode = appError.errorCode;
        this.userMessage = appError.userMessage;
        this.appError = appError;
    }
}
export interface RequestConfig extends RequestInit {
    headers: HeadersInit;
}

export class RequestHandler {
    public async run(url: string, options: RequestConfig): Promise<any> {
        if (options.body) {
            options.body = JSON.stringify(options.body);
        }
        const headers = options.headers ? new Headers(options.headers) : new Headers();

        if (!headers.has('Content-Type')) {
            headers.set('Content-Type', 'application/json');
        }

        options.headers = headers;

        const response = await fetch(url, options);
        const data = await response.json();
        if (!response.ok) {
            const appError = extractErrorFromResponse(data, response.status);
            throw new FetchError(response.status, response.ok, appError);
        }

        return data;
    }
}

diContainer.bindAsConstant(RequestHandler, new RequestHandler());
